import React from 'react';
import { View, FlatList } from 'react-native';
import QuizTitleComponent from "./QuizTitleComponent";
import QuizAnswerComponent from "./QuizAnswerComponent";

class QuizQuestion extends React.Component {


    handleSelection = (newSelectionValue) => {
        this.props.onSelection(newSelectionValue, this.props.questionIndex);
    }

    render() {

        const { questionText, options } = this.props.questionData;

        return (
            <View style={{ alignItems: 'center' }}>
                <QuizTitleComponent title={questionText} />

                {
                    options.map((item, index) => {
                        return (
                            <QuizAnswerComponent
                                key={index.toString()}
                                answer={item.text}
                                onPress={this.handleSelection}
                                index={index}
                                selectedValue={this.props.userSelectionValue}
                            />
                        )
                    })
                }

            </View>
        )
    }
}

export default QuizQuestion;
